import { UnavailableInServerSideError } from '../../../errors/UnavailableInServerSideError';
import { isServerSideRendering } from '../../../utils/isServerSideRendering';
import type { NavigationHandler } from '../navigate.types';

/**
 * Creates a navigation handler that uses the native window.location API.
 */
export const createNavigationHandler = (): NavigationHandler => {
  if (isServerSideRendering()) {
    return () =>
      Promise.reject(
        new UnavailableInServerSideError('createNavigationHandler')
      );
  }

  return async (url) => {
    // eslint-disable-next-line no-restricted-globals -- this is the abstraction for navigation
    window.location.href = url;
  };
};
